// The app's header buttons each open one web panel through an event (SharedWebView fireWebEvent): Torre, search,
// notifications, A+. Each panel listened only for its own, so a second button opened its panel over the first: the
// notifications list on top of an open Torre conversation (Android emulator, 10 Oct 2026). One panel at a time: each
// closes when another one is asked for.
export const PANEL_EVENTS = {
  assistant: 'somostorre:open-assistant-voice',
  search: 'somostorre:open-search',
  notifications: 'somostorre:open-notifications',
  a11y: 'somostorre:open-a11y',
};

/** Call `close` whenever a panel other than `self` is asked for. Returns the cleanup for useEffect. */
export function closeOnOtherPanel(self, close, target = typeof window !== 'undefined' ? window : null) {
  if (!target) return () => {};
  const others = Object.entries(PANEL_EVENTS).filter(([name]) => name !== self).map(([, ev]) => ev);
  others.forEach((ev) => target.addEventListener(ev, close));
  return () => others.forEach((ev) => target.removeEventListener(ev, close));
}
